import { SxProps, Theme } from '@mui/material';

export const buttonSX: SxProps<Theme> = {
	width: '100%',
	paddingTop: '9px',
	paddingBottom: '9px',
};
